import { render, staticRenderFns } from "./picSelector.vue?vue&type=template&id=506741f0&scoped=true"
import script from "./picSelector.vue?vue&type=script&lang=js"
export * from "./picSelector.vue?vue&type=script&lang=js"
import style0 from "./picSelector.vue?vue&type=style&index=0&id=506741f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506741f0",
  null
  
)

export default component.exports